(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('Answer', Answer);

    Answer.$inject = ['$resource', 'DateUtils'];

    function Answer ($resource, DateUtils) {
        var resourceUrl =  'api/answers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationtime = DateUtils.convertDateTimeFromServer(data.creationtime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
